export default __webpack_public_path__ + "static/media/3.c99aa0c6.jpg";